import Path from "@core/FileProvider/Path/Path";
import createDiagrams from "@ext/markdown/elements/diagrams/logic/createDiagrams";
import { getDiagramTypeByExtension } from "@ext/markdown/elements/diagrams/logic/diagramDescriptors";
import createFile from "@ext/markdown/elements/file/edit/logic/createFile";
import ignoreInternalDrags from "@ext/markdown/elements/fileHandler/ignoreInternalDrags";
import createImages from "@ext/markdown/elements/image/edit/logic/createImages";
import { getEditorContext } from "@ext/markdown/elementsUtils/editorContext/EditorContext";
import type { Editor } from "@tiptap/core";
import FileHandler from "@tiptap/extension-file-handler";
import { TextSelection } from "@tiptap/pm/state";

const insertDroppedFiles = async (editor: Editor, files: File[], pos: number) => {
	const { resourceService, apiUrlCreator, articleProps, pageDataContext } = getEditorContext(editor);
	if (!resourceService || !articleProps) return;

	const { view } = editor;
	view.dispatch(view.state.tr.setSelection(TextSelection.near(view.state.doc.resolve(pos))));

	const images = files.filter((file) => file.type.startsWith("image/"));
	const diagrams = files.filter(
		(file) => !file.type.startsWith("image/") && getDiagramTypeByExtension(new Path(file.name).extension),
	);
	const others = files.filter((file) => !images.includes(file) && !diagrams.includes(file));

	if (images.length) await createImages(images, view, articleProps.fileName, resourceService);

	for (const file of diagrams) {
		const path = new Path(file.name);
		await createDiagrams(
			editor,
			path.name,
			resourceService,
			getDiagramTypeByExtension(path.extension),
			pageDataContext,
			await file.text(),
		);
	}

	if (others.length) await createFile(others, view, apiUrlCreator, resourceService);
};

const FileDropHandler = FileHandler.extend({
	addProseMirrorPlugins() {
		return (this.parent?.() ?? []).map(ignoreInternalDrags);
	},
}).configure({
	onDrop: (editor, files, pos) => {
		void insertDroppedFiles(editor, files, pos);
	},
});

export default FileDropHandler;
